import React, { Component } from 'react'
import MappingBranchList from '../../../components/MappingBranchList'
import { SearchOptions } from '../../../components/TableHelper'
import { MappingBranchConsumer } from '../../../context/MappingBranchContext'

type MappingBranchProps = {
  filters: any | null,
  history: any,
  permissions: any,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingBranch extends Component<MappingBranchProps> {

  handleOnLoad = (searchOptions: SearchOptions) => {
    if (this.props.onLoad) {
      this.props.onLoad(searchOptions)
    }
  }

  render() {
    const { permissions, filters, history } = this.props

    return (
      <MappingBranchConsumer>
        {({ fetching, mappingBranches, pagination, requestMappingBranchList }) => {

          return <MappingBranchList permissions={permissions} loading={fetching} mappingBranches={mappingBranches} pagination={pagination} filters={filters} history={history} onLoad={this.handleOnLoad} loadMappingBranches={requestMappingBranchList} />
        }}
      </MappingBranchConsumer>
    )
  }
}
